var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-edit__views"},[_c('vuePaymentInformation'),_c('vueRepaymentMethods'),_c('vueRecurrentPayments'),_c('vueNewCard'),_c('vueRegularAutopayments'),_c('vueDigitalMandates'),_c('vueSetEmiParametrs'),_c('vueMyBalance'),_c('vueWithdrawal'),_c('vueTransfer'),_c('vueEarlyRepayment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }